import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Campaign } from "../../models/campaign.model";
import { Organisation } from "../../models/organisation.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";

let ProfileMenuComponent = {
    selector: "vcProfileMenu",
    templateUrl: "/angular/components/profile-menu/profile-menu.component.html",
    bindings: {
        setSelectedOrganisation: "&",
        changeLiveCampaign: "&",
        switchLeaderView: "&",
        selectedOrganisation: "=",
        user: "=",
    },
    controller: class ProfileMenuController {
        // * bindings for typescript compiler *
        public setSelectedOrganisation: any;
        public changeLiveCampaign: any;
        public switchLeaderView: any;
        public selectedOrganisation: any;
        public user: any;
        // ************************************

        private $rootScope: any;
        private $window: any;
        private readonly dialog: DialogUtils;
        private readonly permissionProvider: PermissionCheck;
        private readonly __env: any;

        public userDataProvider: UserDataProvider;
        public activeCampaign: Campaign;
        public notificationsOpen = false;
        public loadingOrganisations = true;
        public nonOrgCampaignsCount: number | undefined;
        public orgCampaignsCount: number | undefined;
        public organisations: Organisation[];
        public nonOrgCampaigns: Campaign[] = [];
        public isLeaderView: boolean;

        constructor(
            $rootScope: any,
            $window: any,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider,
            PermissionCheck: PermissionCheck,
            __app_type: string,
            __env: any
        ) {
            this.isLeaderView = __app_type == "LEADER";
            this.$rootScope = $rootScope;
            this.$window = $window;
            this.dialog = DialogUtils;
            this.permissionProvider = PermissionCheck;
            this.userDataProvider = UserDataProvider;
            this.__env = __env;

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            CampaignDataProvider.getOrganisations().then(() => {
                this.loadingOrganisations = false;
                this.organisations = CampaignDataProvider.organisations;
                angular.forEach(
                    this.organisations,
                    (organisation: Organisation) => {
                        if (organisation.oid) {
                            this.orgCampaignsCount = [
                                ...organisation.campaigns,
                            ].length;
                        }
                        if (!organisation.oid) {
                            this.nonOrgCampaignsCount =
                                this.nonOrgCampaigns.length +
                                organisation.campaigns.length;
                        }
                    }
                );
            });
        }

        $onInit() {
            this.user = this.userDataProvider.getActiveUser();
        }

        toggleNotificationMenu(open: boolean): void {
            this.notificationsOpen = open;
        }

        changePhoto($event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog.show({
                parent: parentEl,
                component: "vc-image-crop-dialog",
                targetEvent: $event,
                scope: this.$rootScope,
                ariaLabel: "Image Crop",
                size: "auto",
            });
        }

        openCreateAccountDialog(ev: any): void {
            if (this.permissionProvider.hasStripeSubscription) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$rootScope,
                    locals: {
                        conversionType: "create",
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                let createAccountDialog = this.dialog
                    .alert()
                    .title("Please contact us")
                    .textContent(
                        `Please contact ${this.__env.support_email} or ${this.__env.sales_email} to discuss creating additional accounts.`
                    )
                    .targetEvent(ev)
                    .ok("OK");
                this.dialog.showPreConfiguredDialog(createAccountDialog);
            }
        }

        goTo(url: string): void {
            this.$window.location = url;
        }

        changeCampaign(campaign: Campaign, redirect?: string): void {
            this.changeLiveCampaign({ campaign: campaign, redirect: redirect });
        }

        setSelectedOrg(organisation: Organisation): void {
            this.setSelectedOrganisation({ organisation: organisation });
        }

        switchToLeader(organisation: Organisation): void {
            this.switchLeaderView({ organisation: organisation });
        }
    },
};

angular
    .module("profileMenu", [])
    .component(ProfileMenuComponent.selector, ProfileMenuComponent);
